import { useState, } from 'react';
import { TruckIcon, ShoppingCartIcon, CurrencyDollarIcon, DevicePhoneMobileIcon, ClipboardDocumentListIcon, CreditCardIcon, ClipboardDocumentIcon, CpuChipIcon, UserGroupIcon, HomeModernIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import logo from "../assets/logoNA.svg";
import log from "../assets/Services.jpg"

export default function Services() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-sky-500 to-white">
            <nav className="fixed w-full bg-white/90 backdrop-blur-lg shadow-lg z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20"> {/* Increased height */}
                        <div className="flex-shrink-0 flex items-center space-x-3">
                        <div className="relative w-16 h-16">
                                <img src={logo} alt='' />
                            </div>
                            <a href='/' className="text-3xl p-0 m-0 font-bold bg-gradient-to-r from-blue-900 to-sky-600 bg-clip-text text-transparent no-underline leading-tight pb-1">
                                NexusAgents
                            </a>
                        </div>

                        {/* Desktop Menu - Increased text size */}
                        <div className="hidden md:flex space-x-8">
                            <a href="services" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Services</a>
                            <a href="how" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">How It Works</a>
                            <a href="contact" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Contact</a>
                        </div>
                        {/* <a href="login" className="hidden md:flex bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a>
                        <a href="login" className="md:hidden bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a> */}

                        {/* Mobile Menu Button - Larger size */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="md:hidden p-3 rounded-lg text-blue-900 hover:bg-sky-50"
                        >
                            <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu - Larger text */}
                {isMenuOpen && (
                    <div className="md:hidden px-4 pt-2 pb-4 space-y-2">
                        <a href="services" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Services</a>
                        <a href="how" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">How It Works</a>
                        <a href="contact" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Contact</a>
                    </div>
                )}
            </nav>
            {/* Hero Section */}
            <div className="pt-32 " //px-4 sm:px-6 lg:px-8 
            >
                <div className="text-center">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                        Your Complete Local Service Solution
                    </h1>
                    <p className="text-xl text-sky-100 mb-8 max-w-3xl mx-auto">
                        Discover 360° urban living support through our 9 core service verticals,
                        combining traditional reliability with modern convenience.
                    </p>
                    <div className="flex flex-wrap justify-center gap-4 mb-12 max-w-6xl mx-auto">
                        {['Instant Delivery', 'Home Services', 'Digital Solutions', 'Personal Assistance'].map((category, idx) => (
                            <div key={idx} className="px-6 py-2 bg-sky-600/30 rounded-full text-sky-100">
                                {category}
                            </div>
                        ))}
                    </div>
                    <div className='mt-5 max-w-full flex justify-center'>
                        <img src={log} alt='' height={50} className='w-full' />
                    </div>
                </div>

            </div>

            {/* Services Section */}
            <div id="services" className="py-16 bg-white/90 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">Comprehensive Services Portfolio</h2>
                    <button className="text-2xl cursor-pointer rounded-3xl bg-gradient-to-br from-blue-900 via-sky-600 to-sky-400 text-white py-2 px-3 font-bold text-center mb-6">
                    <a href='https://forms.gle/HpqRoMd8WQTR9iks5' 
                    className='flex no-underline text-white justify-center align-items my-auto gap-1'>Order Services Now 
                    <ArrowRightIcon className='w-6 h-6 mt-2' />
                    </a></button>
                    <h6 className='text-center text-blue-900 mb-12'>Services available only in Prayagraj/Allahabad, Uttar Pradesh, India Right Now</h6> 
                    {/* <div className="space-y-10 w-full md:w-1/2 mx-auto"> */}
                    <div className="grid md:grid-cols-2 w-full md:w-3/4 mx-auto gap-8">
                        {[
                            {
                                icon: ShoppingCartIcon,
                                title: 'Mustard Oil',
                                text: 'Buy Mustard(Sarson) Oil and get Delivered directly to your home'
                            },
                            {
                                icon: TruckIcon,
                                title: 'Local Transfers',
                                text: 'Secure delivery of small goods, documents, groceries, and more'
                            },
                            {
                                icon: ShoppingCartIcon,
                                title: 'Daily Shopping',
                                text: 'Let our agents shop your groceries, medicines, dairy products and daily essentials and deliver to your home'
                            },
                            {
                                icon: ClipboardDocumentListIcon,
                                title: 'Personal Errands',
                                text: 'Handle your daily tasks - package pickup, dry cleaning, postal services, document processing and more'
                            }
                            // ,
                            // {
                            //     icon: HomeModernIcon,
                            //     title: 'HouseMaid Service',
                            //     text: 'Professional housemaids for cleaning, cooking, and household maintenance services'
                            // },
                            // {
                            //     icon: TruckIcon,
                            //     title: 'Dawn-to-dusk dairy service',
                            //     text: 'Fresh milk & dairy products delivered to your doorstep'
                            // },
                            // {
                            //     icon: UserGroupIcon,
                            //     title: 'HomeCare Helpers',
                            //     text: 'Dedicated helpers for laundry, utensil cleaning, and home organization'
                            // },
                            // {
                            //     icon: CreditCardIcon,
                            //     title: 'Load Services',
                            //     text: 'Handle all your bill payments, mobile recharges, ticket bookings, and financial transactions'
                            // },
                            // {
                            //     icon: ClipboardDocumentIcon,
                            //     title: 'Data Entry/Admin Support',
                            //     text: 'Comprehensive backend support including data management, documentation, and business process assistance'
                            // },
                            // {
                            //     icon: CpuChipIcon,
                            //     title: 'Technical Advice & Consults',
                            //     text: 'Expert guidance on tech solutions, IT support, and digital transformation strategies'
                            // }
                        ].map((service, idx) => (
                            <div key={idx} className="p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow">
                                <service.icon className="h-14 w-14 text-sky-600 mb-4"
                                // className="h-12 w-12 text-sky-600 mb-4" 
                                />
                                <h3 className="text-xl font-semibold text-blue-900 mb-2">
                                    {/* <h3 className="text-2xl font-semibold text-blue-900 mb-5"> */}
                                    {service.title}</h3>
                                {/* <p className="text-gray-600"> */}
                                <p className="text-xl text-gray-600">
                                    {service.text}</p>
                            </div>
                        ))}
                    </div>
                    {/* Service Legend */}{/* //oil services , gform order */}
                    <div className="mt-12 flex flex-wrap gap-4 justify-center">
                        {[
                            // { color: 'bg-sky-600', text: 'Instant Delivery (Under 2hrs)' },
                            { color: 'bg-blue-900', text: 'Home Services' },
                            { color: 'bg-green-500', text: 'Loads & Transfers' },
                            { color: 'bg-purple-500', text: 'Personal Assistance' }
                        ].map((legend, idx) => (
                            <div key={idx} className="flex items-center gap-2">
                                <div className={`w-4 h-4 ${legend.color} rounded-full`}></div>
                                <span className="text-gray-600 text-sm">{legend.text}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Enhanced Services Section */}
            {/* <div className="py-16 bg-white/90 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">
                        Comprehensive Services Portfolio
                    </h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                icon: TruckIcon,
                                title: 'Smart Courier Service',
                                category: 'Instant Delivery',
                                text: 'Same-hour urban logistics solutions',
                                features: [
                                    'Document transfers (2kg max)',
                                    'Grocery deliveries (within 5km)',
                                    'Medicine pickup & drop',
                                    'E-commerce returns handling'
                                ],
                                tag: 'Most Popular'
                            },
                            {
                                icon: ShoppingCartIcon,
                                title: 'Pro Shopping Assistance',
                                category: 'Personal Assistance',
                                text: 'Expert-guided retail services',
                                features: [
                                    'Weekly grocery planning',
                                    'Medicine availability checks',
                                    'Price comparison reports',
                                    'Specialty store visits'
                                ],
                                tag: 'Daily Essential'
                            },
                            {
                                icon: ClipboardDocumentListIcon,
                                title: 'City Errand Runners',
                                category: 'Personal Assistance',
                                text: 'Metro task management',
                                features: [
                                    'Bank deposit/withdrawal',
                                    'Dry cleaning pickup',
                                    'Post office services',
                                    'Govt. document processing'
                                ],
                                tag: 'Time Saver'
                            },
                            {
                                icon: HomeModernIcon,
                                title: 'HomeCare Experts',
                                category: 'Home Services',
                                text: 'Complete household management',
                                features: [
                                    'Deep cleaning services',
                                    'Meal prep (3/7/30 day plans)',
                                    'Appliance maintenance',
                                    'Emergency repair coordination'
                                ],
                                tag: 'Book Weekly'
                            },
                            {
                                icon: CurrencyDollarIcon,
                                title: 'Milk & Essentials',
                                category: 'Home Services',
                                text: 'Dawn-to-dusk dairy service',
                                features: [
                                    'Daily milk delivery (5AM-7AM)',
                                    'Customizable dairy products',
                                    'Monthly subscription plans',
                                    'Quality guarantee'
                                ],
                                tag: 'Subscription'
                            },
                            {
                                icon: UserGroupIcon,
                                title: 'Home Managers',
                                category: 'Home Services',
                                text: 'Full household support',
                                features: [
                                    'Utensil deep cleaning',
                                    'Wardrobe organization',
                                    'Pantry management',
                                    'Daily chore supervision'
                                ],
                                tag: 'Premium Service'
                            },
                            {
                                icon: CreditCardIcon,
                                title: 'Digital Concierge',
                                category: 'Digital Solutions',
                                text: 'Financial task automation',
                                features: [
                                    'Bill payments & recharges',
                                    'Ticket bookings (travel/events)',
                                    'Insurance premium management',
                                    'Tax filing assistance'
                                ],
                                tag: 'Paperless'
                            },
                            {
                                icon: CpuChipIcon,
                                title: 'Tech Support Hub',
                                category: 'Digital Solutions',
                                text: 'Digital life management',
                                features: [
                                    'Smart home setup',
                                    'Device troubleshooting',
                                    'Software installation',
                                    'Data migration services'
                                ],
                                tag: '24/7 Support'
                            },
                            {
                                icon: ClipboardDocumentIcon,
                                title: 'Biz Assist Pro',
                                category: 'Digital Solutions',
                                text: 'Backoffice solutions',
                                features: [
                                    'Data entry services',
                                    'Inventory management',
                                    'Document digitization',
                                    'CRM maintenance'
                                ],
                                tag: 'SME Special'
                            }
                        ].map((service, idx) => (
                            <div key={idx} className="group relative p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all">
                                {service.tag && (
                                    <div className="absolute top-4 right-4 bg-sky-100 text-sky-800 px-3 py-1 rounded-full text-sm font-medium">
                                        {service.tag}
                                    </div>
                                )}
                                <service.icon className="h-12 w-12 text-sky-600 mb-4" />
                                <div className="mb-2">
                                    <span className="text-sm text-sky-600 font-medium">{service.category}</span>
                                </div>
                                <h3 className="text-xl font-semibold text-blue-900 mb-2">{service.title}</h3>
                                <p className="text-gray-600 mb-4">{service.text}</p>
                                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                    {service.features.map((feature, fIdx) => (
                                        <li key={fIdx} className="text-sm">{feature}</li>
                                    ))}
                                </ul>
                                <div className="mt-4">
                                    <button className="text-sky-600 hover:text-blue-900 font-medium">
                                        Learn More →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>


                </div>
            </div> */}

            {/* CTA Section */}
            <div className="py-16 bg-gradient-to-r from-blue-900 to-sky-600">
                {/* <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">  </div> */}
                <div className="w-full grid md:grid-cols-3 gap-8 mx-auto my-5 text-center px-4 sm:px-6 lg:px-8">
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6 text-center">About NexusAgents</h2>
                        <p className="text-sky-100 mb-8 text-xl text-justify">
                            {/* At NexusAgents, we bridge the gap between busy lives and everyday necessities. As your trusted local service partner, we specialize in secure doorstep deliveries, personalized shopping assistance, and hassle-free errand management. Our network of vetted professionals combines tech-driven efficiency with human-centric care, handling everything from urgent document transfers to meticulous grocery runs. Beyond physical tasks, we empower businesses with administrative support and tech consultations, ensuring both homes and enterprises thrive. With transparent pricing, real-time tracking, and a commitment to reliability, we transform time-consuming chores into seamless experiences. NexusAgents isn’t just a service—it’s your extended team, redefining convenience in the modern world. */}
                            We’re your hyperlocal solution hub, offering secure transfers, deliveries, personal shopping, and errand services for busy lives. With tech-driven agents and vetted pros, we simplify tasks from grocery runs to business paperwork. Trusted reliability, transparent pricing—we turn chores into effortless moments.
                        </p>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Features</h2>
                        <ul className="list-unstyled space-y-4 text-center" aria-label="Quick links">
                            {/* <li><a href="refund" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Refund Policy</a></li> */}
                            <li><a href="terms" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Terms of Service</a></li>
                            <li><a href="privacy" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Convenience?</h2>
                        <p className="text-sky-100 mb-8 text-xl">Join hundreds of satisfied customers today!</p>
                        <div className="flex justify-center space-x-4">
                            {/* <a href='register' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors">
                                Sign Up Now
                            </a> */}
                            <a href='contact' className="border-2 border-white no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-blue-900 text-sky-100 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p>Copyright © 2025 NexusAgents. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}